/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_UnpublishedInputs */

const cs_blog_unpublished = /** @type {(inputs: Blog_UnpublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Článek přesunut do konceptu`)
};

const en_blog_unpublished = /** @type {(inputs: Blog_UnpublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article moved to draft`)
};

/**
* | output |
* | --- |
* | "Article moved to draft" |
*
* @param {Blog_UnpublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_unpublished = /** @type {((inputs?: Blog_UnpublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_UnpublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_unpublished(inputs)
	return cs_blog_unpublished(inputs)
});